export default "__VITE_ASSET__5429b1fc__"